import React from 'react';

import { useAppSelector } from 'shared/lib';
import { AnketaAlert } from 'shared/ui/AnketaAlert';

import { isWLAvitoSelector } from 'entities/whiteLabels';

import { MoreFieldsAlertTexts } from './MoreFieldsAlert.texts';

export const MoreFieldsAlert: FC = () => {
  const isWlAvito = useAppSelector(isWLAvitoSelector);
  return (
    <AnketaAlert
      color="green"
      variant="primary"
      subtitle={isWlAvito ? MoreFieldsAlertTexts.avitoSubtitle : MoreFieldsAlertTexts.subtitle}
    />
  );
};
